var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ableToEdit)?_c('button',{staticClass:"btn text-capitalize action ml-4",class:{completed: _vm.completed, approved: _vm.approved, accepted: _vm.accepted}},[_vm._v("\n  "+_vm._s(_vm.actionLabel)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }